export const GOOD_DELIVERY_TOKEN = '61c8966a4fa13698a47bc27248ee47e3';
export const GOOD_DELIVERY_SECRET = 'd560f59e165dfa0f016785fdd6d66ff2';

export const buildGoodDeliveryQuery = (params) => {
  const searchParams = new URLSearchParams({
    tk: GOOD_DELIVERY_TOKEN,
    sk: GOOD_DELIVERY_SECRET,
    ...params,
  });
  return searchParams.toString();
};
